import { ColumnType } from "antd/lib/table";

const columns: ColumnType<any>[] = [
  {
    title: "CÓDIGO",
    dataIndex: "codigo",
    align: "center",
    render: (value: string) => <span style={{ fontWeight: "bold" }}>{value ?? "-"}</span>,
  },
  {
    title: "DESCRIÇÃO",
    dataIndex: "descricao",
    align: "center",
    render: (value: string) => <span>{value ?? "-"}</span>,
  },
];

export default columns;
